import { IndeterminateProgressCircle } from '@sunwebgroup/uds-ui/IndeterminateProgressCircle'
import { cn } from '@sunwebgroup/uds-ui/utils'
import Script from 'next/script'
import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import styles from './Trustpilot.module.css'

export function Trustpilot() {
  const domainUrl = useConfiguration('domainUrl')
  const { trustpilot: trustpilotBusinessUnitId = '' } = useConfiguration('thirdParties')
  const locale = useConfiguration('locale')
  const publicationCode = useConfiguration('publicationCode')
  const isEliza = PublicationCodes.isElizaPublicationCode(publicationCode)
  const transformedUrl = transformUrl(domainUrl, isEliza)

  return (
    <>
      <Script
        type="text/javascript"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
        strategy="afterInteractive"
      >
      </Script>
      <div
        className={cn('trustpilot-widget', styles.wrapper)}
        data-locale={locale}
        data-template-id="54197383fd9dceac42a68694"
        data-businessunit-id={trustpilotBusinessUnitId}
        data-style-width="100%"
        data-style-size="S"
        data-token="6d93ebd7-fc83-4202-82a9-4962b12c1b51"
        data-stars="3,4,5"
        data-text-color="dark"
        data-border-type="outline"
        data-use-review-snippets="true"
        data-review-snippets-limit="4"
        data-review-snippets-topic="website"
        data-review-snippets-quotes="true"
        data-background="light"
        data-external-elements-color="dark"
      >
        <IndeterminateProgressCircle />
        <a href={`https://www.trustpilot.com/review/${transformedUrl}`} target="_blank" rel="noopener">
          Trustpilot
        </a>
      </div>
    </>
  )
}

function transformUrl(url: string, isEliza: boolean) {
  const withoutProtocol = url.replace(/^https?:\/\//, '')
  return isEliza ? withoutProtocol.replace(/^www\./, '') : withoutProtocol
}
